import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.organization.search.sortFields,
	columnFields: constants.organization.search.columnFields,
	standardFilterFields: constants.organization.search.standardFilterFields,
	dateFilterFields: [] as const,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
